import { IconSize } from "./types";

export const ICON_SIZE_SIZES_PX_UNITLESS: Record<IconSize, number> = {
  sm: 16,
  md: 24,
  lg: 32,
};

export const ICON_SIZE_STROKE_WIDTHS_PX_UNITLESS: Record<IconSize, number> = {
  sm: 0.9,
  md: 1,
  lg: 1.33,
};

export const ICON_SIZES = ["sm", "md", "lg"] as const;
